import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { clientQuery } from '../../../../../../../config/helpers/GraphQLApi';

import { endpoints } from '../../../../../../../config/constants';
import { ExceptionManager } from '../../../../../../../config/helpers/Logging'
import { resetALL } from '../../../../../../../config/redux/actions'

//STATE INITIAL
const INIT_STATE = {
    loading: false,
    data: null,
    error: null
};

const route = 'modules/client/dashboard/views/listTeam/slice'

//Extend async Action
export const teamAnnouncementsListSearch = createAsyncThunk('dashboard/teamAnnouncementsListSearch', async (
    { searchText, limit, offset, filterSendDate, statusId },
    { rejectWithValue, dispatch }
) => {
    const filterDate = {
        filterSendDateIni: filterSendDate ? filterSendDate[0].format('YYYY-MM-DD') : null,
        filterSendDateEnd: filterSendDate ? filterSendDate[1].format('YYYY-MM-DD') : null
    }

    let param1 = '';
    let param2 = '';
    if (statusId) {
        param1 = ',$status: Int';
        param2 = ',status: $status';
    }

    try {
        let data = await clientQuery(
            `query searchTeamAnnouncements($openSearch: String, $limit: Int, $offset: Int ${param1}){
                result: searchTeamAnnouncements(openSearch: $openSearch, limit: $limit, offset: $offset
                    ${param2} ) {
                    items {
                        status
                        id
                        announcementId
                        lastStatusDetailNoteId
                        substatus
                        updatedOn
                        hasOpen
                        contactCount
                        viewCount
                        status
                        createdOn
                        approvedDocument
                        isRequestingForDocument
                        numberNotes
                        updatedStatus {
                            updatedBy { 
                                fullName
                            }
                            updatedOn
                        }
                        totalProgrammedNotes {
                            total
                            totalSent
                            totalSent
                            totalSentByAdmin
                            totalSentByAgents
                            totalSentByAreaManagers
                            totalPending
                            totalPendingByAdmin
                            totalPendingByAreaManagers
                            totalPendingByAgents
                        }    
                        announcement {
                            id
                            product
                            name
                            surname
                        }
                        restrictionAccess {
                            agents {
                                userId
                                fullName
                                hasAccess
                                companyName
                            },
                            affiliatedPartners {
                                userId
                                fullName
                                hasAccess
                                company {
                                    name
                                }
                            },
                            areaManagers {
                                userId
                                fullName
                                hasAccess
                                companyName
                            }
                        }
                        lastNote {
                            note
                            createdOn
                            created {
                                firstName
                                lastName
                            }
                            formAnswer {
                                id
                                answers
                            }
                            form{
                                questions{
                                    id
                                    question
                                    questionType
                                    typeData
                                }
                            }
                        }
                    }
                    count
                    countByStatus
                }
            }`,
            {
                openSearch: searchText || '',
                limit: limit || 10,
                offset: offset || 0,
                status: statusId,
                ...filterDate,
            },
            endpoints.GRAPHQL_GENERAL
        );


        return {...data?.result, countByStatus: JSON.parse(data.result.countByStatus)} || []

    } catch (exc) {
        ExceptionManager(exc, route, 'teamAnnouncementsListSearch', dispatch);
        return rejectWithValue(exc)
    }
})

//Slice
const teamAnnouncementsListRedux = createSlice({
    name: 'dashboard/teamAnnouncements',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE)

        builder.addCase(teamAnnouncementsListSearch.pending, (state) => {
            state.loading = true
        })
        builder.addCase(teamAnnouncementsListSearch.fulfilled, (state, { payload }) => {
            state.loading = false
            state.data = payload
        })
        builder.addCase(teamAnnouncementsListSearch.rejected, (state, action) => {
            state.loading = false
            state.error = action.error.message
        })
    },
})

// Extract and export the action creators object and the reducer
export const { actions, reducer } = teamAnnouncementsListRedux

// Extract and export each action creator by name
export const { reset } = actions

//Simple async action

// Export the reducer, either as a default or named export
export default reducer